import { COLORS } from '@btime/constants'
import { props } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Text, Title } from '../presentation/Text'
import { useCloseModal, useCurrentModal } from '../modals/ModalsContext'
import Button from '../actions/Button'
import ControlledModal from '../modals/ControlledModal'
import FlexGrid, { FlexCol } from '../structure/FlexGrid'
import Icon from '../shapes/Icon'
import Separator from '../helpers/Separator'
import loading from '../helpers/Loading'
import message from './Message'

const AlertContent = () => {
  const { t } = useTranslation()
  const onClose = useCloseModal()
  const {
    data: { icon, onConfirm, title, message, confirmMessage, cancelMessage }
  } = useCurrentModal()

  return (
    <FlexGrid direction="column">
      <Icon name={icon} size="1.6rem" color={COLORS.dark3} />
      <Separator weight={4} />
      <Title size="h3" align="center">
        {title}
      </Title>
      <Text align="center" color={COLORS.dark3}>
        {message}
      </Text>
      <Separator weight={8} />

      <FlexCol>
        <FlexGrid gutter={0.5}>
          <Button transparent onClick={onClose} color={COLORS.dark3}>
            {cancelMessage || t(onConfirm ? 'cancel' : 'close')}
          </Button>
          {!!onConfirm && (
            <Button loading={loading} onClick={onConfirm}>
              {confirmMessage || t('confirm')}
            </Button>
          )}
        </FlexGrid>
      </FlexCol>
    </FlexGrid>
  )
}

const Alert = props => (
  <ControlledModal publicModal {...props}>
    <AlertContent />
  </ControlledModal>
)

export default Alert
